import { Expose, Type } from 'class-transformer';
import { MyActivityModel } from '../models/my-activity.model';
import { BookedStatusEnum } from '../../../store/events/eventTypes';
import { FloorModel } from '../../room/dto/models/floor.model';
import { LocationModel } from '../../room/dto/models/location.model';
import { BuildingModel } from '../../room/dto/models/building.model';
import { EventWithRelationsImpl } from '../../event/dto/implements/event-with-relations.impl';

export class MyActivitiesItemImpl {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'from_date' })
  fromDate: number;
  @Expose({ name: 'to_date' })
  toDate: number;
  @Expose({ name: 'location' })
  @Type(() => LocationModel)
  location: LocationModel;
  @Expose({ name: 'building' })
  @Type(() => BuildingModel)
  building: BuildingModel;
  @Expose({ name: 'floor' })
  @Type(() => FloorModel)
  floor: FloorModel;
  @Expose({ name: 'status' })
  status: BookedStatusEnum;
  @Expose({ name: 'booked_status' })
  bookedStatus: BookedStatusEnum;
  @Expose({ name: 'item' })
  @Type(() => EventWithRelationsImpl)
  item: EventWithRelationsImpl;
}
